module.exports = __webpack_public_path__ + "./favicons/ms-icon-310x310.png";